var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItDept({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7897 8.7696L13.0569 9.7821C10.5895 10.4554 7.9868 10.4554 5.51941 9.7821L1.79004 8.7696V7.4061C1.79004 6.68275 2.07731 5.98902 2.58869 5.47743C3.10007 4.96584 3.79369 4.67828 4.51704 4.67798H14.0627C14.786 4.67828 15.4796 4.96584 15.991 5.47743C16.5024 5.98902 16.7897 6.68275 16.7897 7.4061V8.7696Z",
    stroke: "#44546F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7897 8.76874V14.2239C16.7897 14.9471 16.5024 15.6407 15.9909 16.1521C15.4795 16.6636 14.7859 16.9509 14.0627 16.9509H4.51704C3.79379 16.9509 3.10017 16.6636 2.58876 16.1521C2.07735 15.6407 1.79004 14.9471 1.79004 14.2239V8.76874",
    stroke: "#44546F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0176 4.67707H6.5625V3.99532C6.5625 3.72664 6.61544 3.46059 6.71829 3.21238C6.82115 2.96417 6.9719 2.73865 7.16194 2.54872C7.35198 2.35878 7.57758 2.20815 7.82585 2.10544C8.07412 2.00272 8.34019 1.94993 8.60888 1.95007H9.97238C10.241 1.95007 10.5069 2.00298 10.7551 2.10576C11.0032 2.20854 11.2287 2.35919 11.4186 2.54911C11.6085 2.73903 11.7592 2.9645 11.8619 3.21264C11.9647 3.46078 12.0176 3.72674 12.0176 3.99532V4.67707Z",
    stroke: "#44546F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29053 10.8138V12.1773",
    stroke: "#44546F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItDept);
export default __webpack_public_path__ + "static/media/IT_dept.6c65235522144b13fbdd6bff8a940ca3.svg";
export { ForwardRef as ReactComponent };